var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "home" },
    [
      _c("div", { staticStyle: { padding: "200px" } }, [_vm._v("商城首页2")]),
      _c("DiscountCoupon", { attrs: { visible: true, data: _vm.dcData } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }